import ExitedUserScreen from './ExitedUserScreen';
export default ExitedUserScreen;
